import gql from 'graphql-tag';

export const ORDER_QUERY =
gql`
  query($first: Int, $page: Int) {
    order(first: $first, page: $page) {
      paginator {
        total
      }
      data {
        order_id
        order_number
        status
        price
        ordered_at,
        period_amount
        period_count
        product {
          name
          summary
        }
      }
    }
  }
`;

export const ORDER_DETAIL_QUERY =
gql`
  query($order_id: Int!) {
    orderDetail(order_id: $order_id) {
      order_id
      order_number
      fanpay_order_token
      price
      ordered_at
      period_amount
      period_count
      status
      cancel_reason
      lack_of_document_description
      payment_url
      canceled_at
      recipient {
        name
        phone_number
        postal_code
        county
        area
        address
      }
      product {
        product_id
        name
        price
        summary
        cover_image {
          path
        }
      }
    }
  }
`;
